<script setup lang="ts">

import { useFetchBlockSummary } from '~/api/service/block/summary/index.service'
import RouteButton from '~/components/button/RouteButton.vue'
import ListItemCard from '~/components/card/ListItemCard.vue'
import LoadingDashboardList from '~/components/loading/LoadingDashboardList.vue'
import BcLink from '~/ui/Link/BcLink.vue'
import BcProgress from '~/ui/Progress/BcProgress.vue'

const { data, isLoading } = useFetchBlockSummary(10)
</script>

<template>
  <div v-if="isLoading">
    <LoadingDashboardList />
  </div>
  <div
    v-else-if="data"
    class="flex-col"
  >
    <RouteButton
      class="mb-2"
      label="Latest Block"
      :url="routes.getBlockListPage()"
    />
    <div
      v-for="item in data"
      :key="item"
    >
      <ListItemCard class="list-item-card">
        <NuxtLink
          :to="routes.getBlockDetailPageWithTab(item.BNO, blockDetailPageType.block)"
          class="flex hover:no-underline"
        >
          <div class="block-number-container">
            <div class="flex h-4 w-4 items-center justify-center">
              <FontAwesomeIcon
                class="text-primary"
                icon="cube"
                size="xs"
              />
            </div>
            <div class="ml-2 inline-flex flex-col truncate">
              <BcLink
                :content="item.blockNumber"
                :to="routes.getBlockDetailPageWithTab(item.blockNumber, blockDetailPageType.block)"
                class="truncate text-lg/[1rem] font-bold"
              />
              <span class="mt-1 truncate text-base/[0.75rem] text-primary/40">
                {{ item.AG }}
              </span>
            </div>
          </div>
          <div class="block-detail-container w-full">
            <div class="flex justify-between truncate">
              <div class="flex items-center gap-2 truncate">
                <span class="truncate text-base/[1.125rem] text-primary/40">GAS USED</span>
                <span class="truncate text-lg/[0.875rem] text-primary">{{ item.gasUsed }}</span>
                <Chip
                  class="truncate"
                  :value="`${item.gasUsedPercent} %`"
                />
              </div>
              <span class="truncate text-base/[1.125rem] text-primary text-opacity-40">/ {{
                item.gasLimit
              }}</span>
            </div>
            <div class="mt-1 flex">
              <BcProgress :value="item.gasUsedPercent" />
            </div>
            <div class="mt-3 flex truncate">
              <div class="flex basis-1/2 items-center truncate">
                <span class="truncate text-base/[0.75rem] text-primary/40">TRANSACTIONS</span>
                <span class="ml-2 truncate text-lg/[0.875rem] text-primary">{{
                  item.trxCount
                }}</span>
              </div>
              <div class="flex basis-1/2 items-center truncate">
                <span class="text-base/[0.75rem] text-primary/40">REWARD</span>
                <span class="ml-2 truncate text-lg/[0.875rem] text-primary">{{
                  item.blockReward
                }}</span>
              </div>
            </div>
          </div>
        </NuxtLink>
      </ListItemCard>
    </div>

    <button
      class="bottom-button"
      @click="$router.push(routes.getBlockListPage())"
    >
      <div class="flex items-center justify-center gap-2">
        <span class="text-base/[1.125rem] font-bold text-white">View all blocks</span>
        <FontAwesomeIcon
          icon="chevron-right"
          color="white"
          size="xs"
        />
      </div>
    </button>
  </div>
</template>

<style scoped lang="scss">
.block-number-container {
  @apply inline-flex w-48 truncate;
}

.list-item-card {
  @apply mt-2 h-[88px] p-4;
}

.bottom-button {
  @apply mt-2 h-8 w-full rounded-lg bg-point-color hover:shadow-[0_16px_32px_0_rgba(92,143,250,0.2)];
}
</style>

